import AuthService from "../login/auth.service";
import { dimo, tarjetas } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ExtractoService {
  async ciclos(nroTarjeta) {
    var data = JSON.stringify({
      canal: "WEB",
      numeroTarjeta: nroTarjeta,
    });

    var config = {
      method: "post",
      url: tarjetas + "extractos/ciclos-actual",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }
  async masterHoy(nroTarjeta) {
    var data = JSON.stringify({
      canal: "WEB",
      numeroTarjeta: nroTarjeta,
    });

    var config = {
      method: "post",
      url: tarjetas + "extractos/master-actual",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }
  async masterHoyCu(nroTarjeta) {
    var data = JSON.stringify({
      canal: "WEB",
      numeroTarjeta: nroTarjeta,
    });

    var config = {
      method: "post",
      url: tarjetas + "extractos/master-actual-cu",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }
  async masterAnterior(nroTarjeta, _fecha) {
    var data = JSON.stringify({
      canal: "WEB",
      numeroTarjeta: nroTarjeta,
      fecha: _fecha,
    });
    var config = {
      method: "post",
      url: tarjetas + "extractos/master-anterior-pdf",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  async masterAnteriorPdf(nroTarjeta, _fecha) {
    var data = JSON.stringify({
      canal: "WEB",
      numeroTarjeta: nroTarjeta,
      fecha: _fecha,
    });
    var config = {
      method: "post",
      responseType: "blob",
      url: tarjetas + "extractos/master-anterior-pdf",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  /** SERVICIOS DE CABAL */

  async consultaExtractoCabal(data) {

    var _url = dimo + "dimoTarjetas/consultaExtractos";

    var config = {
      method: "post",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data,
    };

    return await axios(config);

  }


  async descargarExtractoCabal(data) {

    var _url = dimo + "dimoTarjetas/descargaExtractoWeb";

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data
    };

    return await axios(config);

  }


  async consultarMovimientos(data) {
    var _url = dimo + "dimoTarjetas/consultaMovimientos";

    var config = {
      method: "post",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data
    };

    return await axios(config);
  }

  /** */

}
export default new ExtractoService();
